interface Props {
  activeTab: "queue" | "workflow";
  onTabChange: (tab: "queue" | "workflow") => void;
}

export function Header({ activeTab, onTabChange }: Props) {
  return (
    <header className="topbar">
      <div className="topbar-left">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onTabChange("queue");
          }}
          className="logo-link"
          aria-label="Cloudflare — Security Response"
        >
          <CloudflareLogo />
        </a>
        <span className="brand-divider" />
        <span className="brand-product brand-product-single">
          <strong>Security Response Agentic Console</strong>
        </span>
      </div>

      <nav className="topbar-tabs" aria-label="Primary">
        <button
          type="button"
          className={`tab ${activeTab === "queue" ? "active" : ""}`}
          onClick={() => onTabChange("queue")}
        >
          Incidents
        </button>
        <button
          type="button"
          className={`tab ${activeTab === "workflow" ? "active" : ""}`}
          onClick={() => onTabChange("workflow")}
        >
          Workflow
        </button>
      </nav>

      <div className="topbar-right">
        <div className="user-pill">
          <span className="user-avatar">RC</span>
          <span className="user-role">SIRT L1</span>
        </div>
      </div>
    </header>
  );
}

// Official Cloudflare horizontal logo (cloud + wordmark).
// Paths sourced from CF_logo_horizontal_singlecolor_wht.svg at
// cf-assets.www.cloudflare.com. Re-coloured to the full-color brand variant:
//   - cloud top-curve: --cf-tangerine
//   - cloud under-curve: --cf-mango
//   - wordmark: --text (near-black)
function CloudflareLogo() {
  return (
    <svg
      className="cf-logo"
      viewBox="0 0 651.29 94.76"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="img"
    >
      {/* Cloud — top + body (Tangerine) */}
      <path
        fill="#F6821F"
        d="M143.05,93.42l1.07-3.71c1.27-4.41.8-8.48-1.34-11.48-2-2.76-5.26-4.38-9.25-4.57L58,72.7a1.47,1.47,0,0,1-1.35-2,2,2,0,0,1,1.75-1.34l76.26-1c9-.41,18.84-7.75,22.27-16.71l4.34-11.36a2.68,2.68,0,0,0,.18-1,3.31,3.31,0,0,0-.06-.54,49.67,49.67,0,0,0-95.49-5.14,22.35,22.35,0,0,0-35,23.42A31.73,31.73,0,0,0,.34,93.45a1.47,1.47,0,0,0,1.45,1.27l139.49,0h0A1.83,1.83,0,0,0,143.05,93.42Z"
      />
      {/* Cloud — under-curve highlight (Mango) */}
      <path
        fill="#FBAD41"
        d="M168.22,41.15q-1,0-2.1.06a.88.88,0,0,0-.32.07,1.17,1.17,0,0,0-.76.8l-3,10.26c-1.28,4.41-.81,8.48,1.34,11.48a11.65,11.65,0,0,0,9.24,4.57l16.11,1a1.44,1.44,0,0,1,1.14.62,1.5,1.5,0,0,1,.17,1.37,2,2,0,0,1-1.75,1.34l-16.73,1c-9.09.42-18.88,7.75-22.31,16.7l-1.21,3.16a.9.9,0,0,0,.79,1.22h57.63A1.55,1.55,0,0,0,208,93.63a41.34,41.34,0,0,0-39.76-52.48Z"
      />
      {/* Wordmark "CLOUDFLARE" */}
      <g fill="#1d1d1f">
        <polygon points="273.03 59.66 282.56 59.66 282.56 85.72 299.23 85.72 299.23 94.07 273.03 94.07 273.03 59.66" />
        <path d="M309.11,77v-.09c0-9.88,8-17.9,18.58-17.9s18.48,7.92,18.48,17.8v.1c0,9.88-8,17.89-18.58,17.89S309.11,86.85,309.11,77m27.33,0v-.09c0-5-3.59-9.29-8.85-9.29s-8.7,4.22-8.7,9.19v.1c0,5,3.59,9.29,8.8,9.29s8.75-4.23,8.75-9.2" />
        <path d="M357.84,79V59.66h9.69V78.78c0,5,2.5,7.33,6.34,7.33s6.34-2.26,6.34-7.08V59.66h9.68V78.73c0,11.11-6.34,16-16.12,16s-15.93-5-15.93-15.73" />
        <path d="M404.49,59.66h13.27c12.29,0,19.42,7.08,19.42,17v.1c0,9.93-7.23,17.3-19.61,17.3H404.49Zm13.42,26c5.7,0,9.49-3.15,9.49-8.71v-.09c0-5.51-3.79-8.71-9.49-8.71H414V85.62Z" />
        <polygon points="451.04 59.66 478.56 59.66 478.56 68.02 460.58 68.02 460.58 73.87 476.85 73.87 476.85 81.78 460.58 81.78 460.58 94.07 451.04 94.07 451.04 59.66" />
        <polygon points="491.84 59.66 501.37 59.66 501.37 85.72 518.04 85.72 518.04 94.07 491.84 94.07 491.84 59.66" />
        <path d="M543,59.42h9.19L566.8,94.07H556.58l-2.51-6.14H540.79l-2.45,6.14h-10Zm8.35,21.08-3.83-9.78L543.6,80.5Z" />
        <path d="M579.08,59.66h16.27c5.27,0,8.9,1.38,11.21,3.74a10.64,10.64,0,0,1,3.05,8v.1a10.88,10.88,0,0,1-7.08,10.57l8.21,12h-11L592.8,83.65h-4.18V94.07h-9.54Zm15.83,16.52c3.25,0,5.12-1.58,5.12-4.08V72c0-2.71-2-4.08-5.17-4.08h-6.24v8.26Z" />
        <polygon points="623.37 59.66 651.05 59.66 651.05 67.77 632.81 67.77 632.81 72.98 649.33 72.98 649.33 80.5 632.81 80.5 632.81 85.96 651.29 85.96 651.29 94.07 623.37 94.07 623.37 59.66" />
        <path d="M252.15,81a8.44,8.44,0,0,1-7.88,5.16c-5.22,0-8.8-4.33-8.8-9.29v-.1c0-5,3.49-9.2,8.7-9.2a8.64,8.64,0,0,1,8.18,5.71h10C260.79,65.09,253.6,59,244.27,59c-10.62,0-18.58,8-18.58,17.9V77c0,9.88,7.86,17.8,18.48,17.8,9.08,0,16.18-5.88,18.05-13.76Z" />
      </g>
    </svg>
  );
}
